// extracted by mini-css-extract-plugin
export default {"tile_container":"wba","tile_img_container":"xba","not_recommended_label":"yba","modal_root":"zba","content":"Aba","warning":"Bba","x_mark":"Cba","tile_img":"Eba","tile_type":"Fba","tile_product_title":"Gba","tile_product_price":"Hba","tile_descr_line":"Iba","tile_descr_icon":"Jba","info_icon":"Kba","tile_descr_text":"Lba","tile_btns_container":"Mba","info_container":"Nba","info_text":"Oba"};
    if(module.hot) {
      // 1726593108469
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  